import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllRecordings } from '../../../views/pvr/actions';

export function useLegacyRecordings() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.pvrReducer.recordings);
  const isLoading = useSelector((state) => state.pvrReducer.recordingsLoading);

  useEffect(() => {
    if (!data) {
      dispatch(fetchAllRecordings(false));
    }
  }, [data, dispatch]);

  return useMemo(() => ({ data, isLoading }), [data, isLoading]);
}
